import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Progress} from 'kpc';

var _$tmp0 = {
    'percent': '0',
    'showInnerText': true,
    'showOuterText': false
};
var _$tmp1 = {
    'percent': '50',
    'showInnerText': true,
    'showOuterText': false
};
var _$tmp2 = {
    'percent': '60',
    'status': 'error',
    'showInnerText': true,
    'showOuterText': false
};
var _$tmp3 = {
    'percent': '70',
    'status': 'success',
    'showInnerText': true,
    'showOuterText': false
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Progress, _$tmp0),
        _$cc(Progress, _$tmp1),
        _$cc(Progress, _$tmp2),
        _$cc(Progress, _$tmp3)
    ], 4);
};